<template>
    <div class="pass-login">
        <div id="pass-login-main" class="pass"></div>
    </div>
</template>
<script>
/**
 * @file pass.vue
 * @desc pass登录入口
 * @author baoleilei@baidu.com
 * @date 2019-9-25
 */
import {passportOrigin, ucPassportOrigin} from '../../../config/constant';
import {mapState} from 'vuex';
const isDevelopment = process.env.NODE_ENV === 'development';
const passDomain = `${passportOrigin}/passApi/js/wrapper.js`;
const ucPassDomain = `${ucPassportOrigin}/staticv2/dep/common-login/api.js`;
// const ucPassDomain = `${ucPassportOrigin}/staticv2/dep/common-login/${isDevelopment ? 'qa-' : ''}api.js`;
const passCrossDomainUrl = location.protocol + '//' + location.host
    + (isDevelopment ? '/v3Jump.html' : '/pc/static/v3Jump.html');
// 登录成功后要跳转的地址，此 url 需要接入 casClient
let jumpPage = location.protocol + '//' + location.host + '/fp/account/index/lawinfo'
    + (location.search.includes('?') ? location.search + '&source=login' : '?source=login');
export default {
    name: 'PASS',
    data() {
        return {
            industry: 'law'
        };
    },
    components: {
    },
    computed: {
        ...mapState({
            ind: state => state.Industry.ind,
            isLogin: state => state.Menu.isLogin,
            userInfoStatus: state => state.Menu.userInfoStatus,
            userType: state => state.Menu.userType,
            firstApprove: state => state.Menu.firstApprove,
            userInfoNew: state => state.lawStore.userInfoNew || {}
        })
    },
    mounted() {
        // 加载passport 文档 http://wiki.baidu.com/display/cbase/UniformLogin
        if (+this.isLogin === 1) {
            // uc角色-登录用户
            // if (+this.userInfoNew?.uc_shadow_type === 1) {
            //     const urlName = this.$router.history.current.name;
            //     urlName !== 'clueBillManage' && this.$router.push({
            //         name: 'clueBillManage',
            //         query: {
            //             fr: this.$wywLog?.getAllKey().originFr || ''
            //         }
            //     });
            //     return;
            // }
            if (+this.userType === 2) {
                this.$http.get('/bp/api/business/getroleinfo', {
                }).then(res => {
                    let data = res?.data || {};
                    const lawBjhStatus = data.bjhInfo?.status || '';
                    const subType = data.bjhInfo?.subType || '';
                    let businessId = data.businessInfo?.id || '';
                    this.$router.push({
                        name: lawBjhStatus === 'pass' && (subType === 'company' || subType === 'other')
                            && businessId ? 'lawclues' : 'filldata'
                    });
                }).catch(err => {
                    this.$normalizeResponseError(err);
                });
                return;
            }
            if (
                (+this.userInfoStatus === 0 && +this.userType === 0)
                || (+this.userType !== 3 && this.firstApprove === 0)
            ) {
                const urlName = this.$router.history.current.name;
                urlName !== 'filldata' && this.$router.push({
                    name: 'filldata',
                    query: {
                        fr: this.$wywLog?.getAllKey().originFr || 'lvlin_login'
                    }
                });
                return;
            }
            if (+this.userInfoStatus === 10 && +this.userType === 0) {
                const urlName = this.$router.history.current.name;
                urlName !== 'LawVerifyGuide' && this.$router.push({
                    name: 'LawVerifyGuide'
                });
                return;
            }
            let map = {
                0: 'lawinfo', // 律师
                1: 'lawTpInfo', // 代理商
                2: 'firmintro', // 律所
                3: 'lawTpInfo'// 代理商
            };
            this.$router.push({
                name: map[+this.userType] || 'lawclues'
            });
            return;
        }
        this.passLogin();
        // this.ucLogin();
    },
    methods: {
        passLogin() {
            let script = document.createElement('script');
            const product = this.ind[this.industry].product;
            script.src = passDomain;
            document.body.appendChild(script);
            script.onload = () => {
                window.passport.use('login', {
                    tangram: true,
                    loginVersion: 'v5', // v5文档：http://wiki.baidu.com/pages/viewpage.action?pageId=1538629082
                    defaultCss: true
                }, function (magic) {
                    // eslint-disable-next-line
                    let passLogin = new magic.passport.login({
                        product: product,
                        loginType: 1,
                        loginMerge: true, // 是否合并
                        hasRegUrl: true, // 是否有注册链接
                        autosuggest: true, // 是否自动提示
                        hasPlaceholder: true, // 是否有placeholder
                        authsiteLogin: ['qzone', 'tsina', 'weixin'], // 第三方登录
                        u: jumpPage,
                        isPhone: false,
                        safeFlag: 0,
                        staticPage: passCrossDomainUrl,
                        mustVerify: 0,
                        registerLink: 'https://passport.baidu.com/v2/?reg&tpl=ps&u=https://lvlin.baidu.com/pc/h', // 注册地址
                        hideLogo: 1 // 是否隐藏百度logo（默认为0展示logo，1 隐藏百度logo）
                    });
                    passLogin.render('pass-login-main');
                });
            };
        },

        /**
         * uc登录
         * 参考文档： https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/DDWA7rKjDG/ctFiYDJ-YO/30Hmnzo8YDHIJt
         */

        ucLogin() {
            let script = document.createElement('script');
            const product = this.ind[this.industry].product;
            script.src = ucPassDomain;
            document.body.appendChild(script);
            script.onload = () => {
                window.ucCommonLogin && window.ucCommonLogin.init({
                    // 登录框渲染父节点 DOM ID
                    container: 'pass-login-main',
                    // 产品线ID 使用 http://iuc.baidu.com/ 申请
                    appid: 762,
                    // 回跳地址
                    fromu: jumpPage,
                    // v3Jump.html 页面地址，需要在自己的域下
                    staticPage: passCrossDomainUrl,
                    // 0或1，默认为0，是否使用uc/passport双账号登陆
                    multiLogin: 1,
                    // 'passport'或'uc'，只在启用multiLogin之后生效，同时支持 passport和 UC登录时，默认登录tab为 passport还是UC。默认为'passport'。
                    defaultLogin: 'passport',
                    // 产品线标志，原passport接口中tpl字段
                    product: product,
                    defaultCss: 1,
                    defaultCssVersion: 2,
                    // 详见 http://wiki.baidu.com/pages/viewpage.action?pageId=847807789#:~:text=%E6%98%BE%E7%A4%BA%E6%B3%A8%E5%86%8C%E9%93%BE%E6%8E%A5-,passUseOptions,-%E5%90%A6
                    passUseOptions: {
                        loginVersion: 'v4',
                        // 是否使用 Passport 默认样式
                        defaultCss: true
                    },
                    // 详见 http://wiki.baidu.com/pages/viewpage.action?pageId=847807789#:~:text=passport/loginv4.text-,passLoginOptions,-%E5%90%A6
                    passLoginOptions: {
                        // 短信登录，可选
                        // sms: 5,
                        // 默认帐号密码登录
                        userPwdLogin: 1,
                        // 第三方登录
                        authsiteLogin: ['qzone', 'tsina', 'weixin']
                    }
                });
            };
        }
    }
};
</script>
<style lang="less" scoped>
.pass-login {
    padding-top: 30px;
    width: 400px;

    /deep/ .tang-pass-login .pass-generalError {
        height: auto;
    }

    /deep/.tang-pass-login .pass-fgtpwd {
        margin-top: -15px;
        padding-bottom: 8px;
    }
}
</style>